import classNames from 'classnames';

import useStyles from './styles';

function UseCaseWithToggleSkeleton() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <i className={classNames(styles.title, styles.titleFallback, 'skeleton')} />
      <i className={classNames(styles.title, styles.titleFallback, 'short', 'skeleton')} />

      <div className={styles.togglesHolder}>
        <i className={classNames(styles.togglesFallback, 'skeleton')} />
      </div>

      <i className={classNames(styles.description, styles.descriptionFallback, 'skeleton')} />
      <i
        className={classNames(styles.description, styles.descriptionFallback, 'short', 'skeleton')}
      />

      <div className={styles.imgHolder}>
        <i className={classNames(styles.img, styles.imgFallback, 'skeleton')} />
      </div>
    </div>
  );
}

export default UseCaseWithToggleSkeleton;
